import React, { useState, useEffect, useCallback } from 'react';
import Services from '../services/services';
import BodyContainer from '../ui/BodyContainer';
import CustomTable from '../ui/customTable';
import CustomButton from '../ui/viewEventUi/CustomButton';
import toast, { Toaster } from 'react-hot-toast';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
// import GroupSharpIcon from '@material-ui/icons/GroupSharp';
import Typography from '@material-ui/core/Typography';
import { getUserBrowserStorage } from '../constants';
import { groupIcon } from '../ui/icons';

const useStyles = makeStyles((theme) => ({
  gridOccupy: {
    width: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
  icon: {
    fill: '#fff',
  },
  signinBtn: {
    // marginTop: '1rem',
    backgroundColor: 'transparent', //125AB8 --old
    borderColor: '#000',
    minWidth: theme.spacing(14),
    borderWidth: theme.spacing(0.2),
    '&:hover': {
      color: '#00acc1',
      backgroundColor: '#D7DBDD', //125AB8 --old
      borderColor: '#00acc1',
    },
  },
}));

function ViewUsers() {
  const classes = useStyles();
  const [backendRes, setBackendRes] = useState([]);
  const [allUsersList, setAllUsersList] = useState([]);
  const [dummyState, setDummyState] = useState(false); //this is being used to refresh table data when some role change is successful
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));

  const showLoadToaster = (msg) => {
    // toast.dismiss();
    const toastId = toast.loading(msg);
    return toastId;
  };

  const showSuccToaster = (msg, toastId) => {
    toast.success(msg, { id: toastId });
  };

  const showErrToaster = (msg, toastId) => {
    toast.error(msg, { id: toastId });
  };

  const genReqFunc = (userId, userType) => {
    // loginUserId, userId, userType,
    const changeRoleReq = {};
    switch (userType) {
      case 2:
        changeRoleReq.loginUserId = userDetails.userId;
        changeRoleReq.userId = userId;
        changeRoleReq.userType = 3;
        return changeRoleReq;

      case 3:
        changeRoleReq.loginUserId = userDetails.userId;
        changeRoleReq.userId = userId;
        changeRoleReq.userType = 2;
        return changeRoleReq;

      default:
        return changeRoleReq;
    }
  };

  const actionClickHandle = async ({ userId, userType }) => {
    toast.dismiss();
    const toastId = showLoadToaster('Please wait');
    const changeRoleReq = genReqFunc(userId, userType);
    if (Object.keys(changeRoleReq).length) {
      try {
        const res = await Services.change_role(changeRoleReq);
        if (res.data.responseCode === 200) {
          setDummyState((prevState) => !prevState);
          if (changeRoleReq.userType === 2) {
            showSuccToaster('Role changed to Host', toastId);
            return;
          } else if (changeRoleReq.userType === 3) {
            showSuccToaster('Role changed to user', toastId);
            return;
          }
        }
        showErrToaster('Error changing role', toastId);
      } catch (error) {
        showErrToaster('Error changing role', toastId);
      }
    } else {
      showErrToaster('Error changing role', toastId);
    }
  };

  const columns = [
    { field: 'id', headerName: 'S.No:', width: 100, filterable: false },
    { field: 'fullName', headerName: 'Name', width: 200, filterable: false },
    { field: 'email', headerName: 'Email Id', width: 250 },
    { field: 'phone', headerName: 'Mobile No.', width: 150, filterable: false },
    {
      field: 'role',
      headerName: 'Current Role',
      width: 150,
      filterable: false,
    },
    {
      field: 'action',
      headerName: 'Action',
      renderCell: (params) => (
        <CustomButton
          clickHandle={() => actionClickHandle(params.value)}
          btnText={'change role'}
          btnStyle={classes.signinBtn}
        />
      ),
      width: 150,
    },
  ];

  // const icon = <GroupSharpIcon className={classes.icon} />;

  const getAllUsers = async () => {
    // const toastId = showLoadToaster('Please wait');

    try {
      const res = await Services.list_users(1);
      if (res.data.responseCode === 200) {
        // showSuccToaster('All users', toastId);
        const employeeUserList = res.data.employeeUserList;
        const hostUserList = res.data.hostUserList;
        const allUsers = [...hostUserList, ...employeeUserList];
        // setAllUsersList(allUsers);
        setBackendRes(allUsers);
        return;
      }
      // showErrToaster('Error loading users', toastId);
    } catch (error) {
      // showErrToaster('Error loading users', toastId);
    }
  };

  const setRole = (userType) => {
    switch (userType) {
      case 1:
        return 'Admin';
      case 2:
        return 'Host';
      case 3:
        return 'User';

      default:
        return 'Unknown';
    }
  };

  const createData = useCallback((backendRes) => {
    const dataToTable = backendRes.map((item, index) => {
      const x = {
        id: index + 1,
        fullName: item.firstName + ' ' + (item.lastName || ''),
        email: item.email,
        phone: item.phone || '-',
        role: setRole(item.userType),
        action: { userId: item.userId, userType: item.userType },
      };
      return x;
    });
    // setTableBody(dataToTable);
    return dataToTable;
  }, []);

  useEffect(() => {
    const formattedList = createData(backendRes);
    setAllUsersList(formattedList);
  }, [backendRes, createData]);

  useEffect(() => {
    getAllUsers();
  }, [dummyState]);

  return (
    <BodyContainer title="View Users" icon={groupIcon()}>
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          {allUsersList.length ? (
            <CustomTable listData={allUsersList} columns={columns} />
          ) : (
            <Typography style={{ alignSelf: 'flex-start' }}>
              No users to display
            </Typography>
          )}
        </Paper>
      </Grid>
      <Toaster position="top-center"></Toaster>
    </BodyContainer>
  );
}

export default ViewUsers;
